import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#customized-template" }),
  /*#__PURE__*/_createTextVNode(" Customized Template ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" ElementPlus only provides the most common template, sometimes that could be a problem, so you have a slot named "),
  /*#__PURE__*/_createVNode("code", null, "template"),
  /*#__PURE__*/_createTextVNode(" to do that work."),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Also we have provided different types skeleton unit that you can choose, for more detailed info, please scroll down to the bottom of this page to see the API description. Also, when building your own customized skeleton structure, you should be structuring them as closer to the real DOM as possible, which avoiding the DOM bouncing caused by the height difference. ")
], -1)
const _hoisted_4 = { class: "rounded border p-10" }
const _hoisted_5 = { style: {"padding":"14px"} }
const _hoisted_6 = { style: {"display":"flex","align-items":"center","justify-items":"space-between"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")
  const _component_el_skeleton = _resolveComponent("el-skeleton")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_el_skeleton, { style: {"width":"240px"} }, {
        template: _withCtx(() => [
          _createVNode(_component_el_skeleton_item, {
            variant: "image",
            style: {"width":"240px","height":"240px"}
          }),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_el_skeleton_item, {
              variant: "p",
              style: {"width":"50%"}
            }),
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"margin-right":"16px"}
              }),
              _createVNode(_component_el_skeleton_item, {
                variant: "text",
                style: {"width":"30%"}
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}